import type { Middleware } from '@reduxjs/toolkit';
import { showToast } from '../slices/uiSlice';

// Error messages mapping
const getErrorMessage = (error: unknown): string => {
  if (typeof error === 'string') return error;

  const err = error as { message?: string; error?: string; status?: number };
  if (err?.message) return err.message;
  if (err?.error) return err.error;

  // API error patterns
  if (err?.status === 401) return 'Please log in to continue';
  if (err?.status === 403) return 'You do not have permission for this action';
  if (err?.status === 404) return 'Resource not found';
  if (err?.status === 500) return 'Server error. Please try again later';

  return 'An unexpected error occurred';
};

export const errorHandlingMiddleware: Middleware = (store) => (next) => (action) => {
  // Catch all rejected actions
  if (action.type.endsWith('/rejected')) {
    const error = action.error || action.payload;

    // Log to monitoring service (replace with your service)
    if (process.env.NODE_ENV === 'production') {
      console.error('Redux Error:', {
        action: action.type,
        error,
        timestamp: new Date().toISOString(),
        user: store.getState().auth?.user?.id,
      });
    }

    // Show user-friendly error toast
    store.dispatch(
      showToast({
        type: 'error',
        message: getErrorMessage(error),
        duration: 7000,
      })
    );
  }

  return next(action);
};
